import React, { ReactNode } from "react"
import { Button } from "./Button"
export function CustomFilledButton({ children, disabled, onClick, className, loading = false }: { children: ReactNode, disabled?: boolean, className?: string, onClick: () => void, loading?: boolean }): JSX.Element {
  return <Button onClick={onClick} className={`h-10 px-8 w-fit bg-cents-purple text-cents-white font-medium rounded-xl transition-all duration-300 ease-out flex items-center justify-center`
    .concat(className ? ` ${className}` : "")} disabled={disabled || loading} loading={loading}>
    {children}
  </Button>
}